import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { Avatar, Box, Card, CardContent, CardHeader, Divider, IconButton, Typography } from '@mui/material';
import { formatGoalLabel, formatPrice } from '../columns';
import { ForecastYears, StockRow } from '../types';
import { getClassColor } from '../utils/getClassColor';
import { getGoalValue } from '../utils/getGoalValue';
import { ProgressBar } from './ProgressBar';

const rowStyle = { bgcolor: 'white', width: '100%' };

function DividendLine({ year, dividendYield, dividend }: { year: string; dividendYield: string; dividend: string }) {
  return (
    <CardContent>
      <Box display={'flex'} flexDirection={'row'} gap={5}>
        <Typography>{`DY ${year}`}</Typography>
        <Typography>{dividendYield.split(' | ').at(0)}</Typography>
        <Typography>{`R$ ${dividend} / Ação`}</Typography>
      </Box>
    </CardContent>
  );
}

type StockCardProps = {
  row: StockRow;
  years: ForecastYears;
  onEdit: () => void;
};

/** Cartão de um ativo da carteira, usado no celular no lugar da tabela. */
export function StockCard({ row, years, onEdit }: StockCardProps) {
  const hasForecast = Number(row.start) > 0;

  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardHeader
        avatar={<Avatar alt="Remy Sharp" src={row.logo} />}
        action={
          <IconButton aria-label="settings" onClick={onEdit}>
            <ModeEditIcon />
          </IconButton>
        }
        title={row.ticker}
        subheader={
          <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} gap={1}>
            <Typography variant='h5'>{formatPrice(row)}</Typography>
            <Typography variant='body2' className={getClassColor(row.changePct)}>{row.changePct}</Typography>
          </Box>
        }
      />
      <CardContent>
        <Box sx={rowStyle} display={'flex'} flexDirection={'row'} gap={5} justifyContent={'space-between'}>
          <Typography variant='h6'>Qtd.</Typography>
          <ProgressBar value={getGoalValue(row.quantity, row.goal)} label={formatGoalLabel(row)} maxWidth={170} />
        </Box>
      </CardContent>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={rowStyle} display={'flex'} flexDirection={'row'} gap={5} justifyContent={'space-between'}>
          <Typography variant='h6'>Score</Typography>
          <ProgressBar value={Number(row.score)} label={`${Math.round(Number(row.score) ?? 0)}%`} maxWidth={170} />
        </Box>
        <Typography variant='body1'>{row.description}</Typography>
      </CardContent>
      {hasForecast && <DividendLine year={`${Number(years.start) - 1}`} dividendYield={row.lastDY} dividend={row.last} />}
      {hasForecast && <DividendLine year={years.start} dividendYield={row.startDY} dividend={row.start} />}
      {Number(row.end) > 0 && <DividendLine year={years.end} dividendYield={row.endDY} dividend={row.end} />}
      <Divider />
    </Card>
  );
}
